import React from 'react';
import thetaEdgeNodeWordmark from '../../assets/icons/home/theta-edge-node-wordmark.svg';
import edgeCloudWordmark from '../../assets/icons/home/theta-edgecloud-wordmark.svg';

const DownloadClientsSection = () => {
    return (
        <div className={'DownloadClients'}>
            <h2 className={'DownloadClients__title'}>DOWNLOAD CLIENTS</h2>
            <p className={'DownloadClients__subtitle'}>Join the network and start computing</p>

            <div className={'DownloadClients__cards'}>
                <div className={'DownloadClients__card DownloadClients__card--green'}>
                    <img className={'DownloadClients__earn-badge'}
                         src={'/images/badges/earn-tfuel@2x.png'}
                         alt={'Earn TFUEL'}
                    />
                    <div className={'DownloadClients__card-inner'}>
                        <img className={'DownloadClients__card-logo'}
                             src={thetaEdgeNodeWordmark}
                             alt={'Theta Edge Node'}
                        />
                        <p className={'DownloadClients__card-description'}>
                            Contribute distributed CPU/GPU resources
                        </p>
                        <a className={'DownloadClients__card-cta DownloadClients__card-cta--green'}
                           href={'/join'}
                        >
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M7 2V12M7 12L3 8M7 12L11 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Download
                        </a>
                    </div>
                </div>

                <div className={'DownloadClients__card DownloadClients__card--purple'}>
                    <div className={'DownloadClients__card-inner'}>
                        <img className={'DownloadClients__card-logo'}
                             src={edgeCloudWordmark}
                             alt={'EdgeCloud Hybrid Client'}
                        />
                        <p className={'DownloadClients__card-description'}>
                        Make your GPU node available on the platform
                        </p>
                        <a className={'DownloadClients__card-cta DownloadClients__card-cta--purple'}
                           href={'https://docs.thetatoken.org/docs/theta-edgecloud-client-guide'}
                           target={'_blank'}
                           rel={'noopener noreferrer'}
                        >
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M7 2V12M7 12L3 8M7 12L11 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Download
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DownloadClientsSection;
